import { Card } from '../Card';
import { Button } from '../Button';

interface PaymentMethodCardProps {
  onManagePayment: () => void;
  isLoading?: boolean;
}

export function PaymentMethodCard({ onManagePayment, isLoading = false }: PaymentMethodCardProps) {
  return (
    <Card title="Payment Method">
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Manage your payment methods, update billing information, and view your payment history through
          our secure payment portal powered by Paddle.
        </p>

        <div className="bg-info/10 border border-info/20 rounded-md p-4">
          <h4 className="text-sm font-medium text-info mb-2">What you can do:</h4>
          <ul className="text-sm text-info space-y-1 list-disc list-inside">
            <li>Update credit card information</li>
            <li>Change billing address</li>
            <li>View payment history</li>
            <li>Download past invoices</li>
          </ul>
        </div>

        <Button onClick={onManagePayment} isLoading={isLoading} className="w-full">
          Open Payment Portal
        </Button>

        <p className="text-xs text-muted-foreground text-center">
          You will be securely redirected to Paddle's payment portal
        </p>
      </div>
    </Card>
  );
}
